// Gavetas da V3 (<dialog class="ds-drawer">): abrir por [data-ds-open="<id do dialog>"], fechar por
// [data-ds-close], clique fora do painel (no fundo) ou Esc (nativo do <dialog>).
// Sem JS ou sem <dialog>, quem abre é um link e segue pro endereço dele (href de reserva).
export function abrir(id, origem) {
  const d = document.getElementById(id);
  if (!d || typeof d.showModal !== "function") return false;
  if (!d.open) {
    d.dsOrigem = origem ?? document.activeElement;
    d.showModal();
    document.documentElement.classList.add("ds-drawer-open");
  }
  return true;
}

document.addEventListener("click", (e) => {
  const gatilho = e.target.closest?.("[data-ds-open]");
  if (gatilho) {
    if (abrir(gatilho.dataset.dsOpen, gatilho)) e.preventDefault();
    return;
  }
  if (e.target.closest?.("[data-ds-close]")) {
    e.target.closest("dialog")?.close();
    return;
  }
  // clique no fundo: o alvo é o próprio <dialog> (o painel ocupa todo o conteúdo)
  if (e.target instanceof HTMLDialogElement && e.target.classList.contains("ds-drawer")) e.target.close();
});

document.addEventListener(
  "close",
  (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDialogElement) || !d.classList.contains("ds-drawer")) return;
    if (!document.querySelector("dialog.ds-drawer[open]")) document.documentElement.classList.remove("ds-drawer-open");
    d.dsOrigem?.focus?.();
  },
  true
);

window.ArpineDrawer = { abrir };
